// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"MenuTrigger_hamburger__8PwjG","bun":"MenuTrigger_bun__dd_nj","burger":"MenuTrigger_burger__2NIo2"};